import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IDeleteWatchlistUseCase {
    execute(
        type: 'linear' | 'vod',
        apiKey: string,
        profileName: string,
        ids: string[],
        token: string,
        identityToken: string
    ): Promise<any>;
}

export class DeleteWatchlistUseCase implements IDeleteWatchlistUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        type: 'linear' | 'vod',
        apiKey: string,
        profileGuid: string,
        ids: string[],
        token: string,
        identityToken: string
    ): Promise<boolean> {
        const id = ids.join(',');
        const result = await this.profileRepository.deleteWatchlist(
            type,
            apiKey,
            profileGuid,
            id,
            token,
            identityToken
        );
        return result.data.code === 'accepted';
    }
}
